'use client';
import { useUpdateAppModal } from '@capsicum/socios-core-web';
import { useEffect } from 'react';

type UpdateAppProps = {
	isForcedRequirement?: boolean;
	onDismiss?: () => void;
};

export const UpdateApp = ({ isForcedRequirement, onDismiss }: UpdateAppProps) => {
	const { showUpdateAppModal } = useUpdateAppModal({ isForcedRequirement, onDismiss });

	useEffect(() => {
		showUpdateAppModal();
	}, []);

	return null;
};
